import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, PaginatedAppointmentPayRateLookupList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
}

interface IUseAppointmentPayRateLookups {
  ordering?: string;
  staff: string;
  limit?: string;
}

function useAppointmentPayRateLookups({
  ordering,
  staff,
  limit = '20',
}: IUseAppointmentPayRateLookups): UseInfiniteQueryResult<
  AxiosResponse<PaginatedAppointmentPayRateLookupList>
> {
  const fetchAppointmentPayRateLookups = useCallback(
    ({
      pageParam = { limit, offset: '0' },
    }: QueryKeyType): Promise<AxiosResponse<PaginatedAppointmentPayRateLookupList>> => {
      const params = pageParam;
      if (ordering) {
        params.ordering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`).concat(',pk');
      }
      if (staff) {
        params.staff = staff;
      }
      return client.get(`appointment-pay-rate-lookups/?${encodeUrlParams(pageParam)}`);
    },
    [limit, ordering, staff],
  );

  return useInfiniteQuery(['appointmentPayRateLookups', ordering, staff], fetchAppointmentPayRateLookups, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
    enabled: !!staff,
  });
}

export default useAppointmentPayRateLookups;
